import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LoaderLight from './LoaderLight';
import Container from './Container';
import {
  background,
  dimension,
  margin,
  padding,
  display,
  flexParent,
  flexChild,
  font,
  border,
  position,
} from '../styleHelper2';

const style = props => {
  const { theme, border: hasBorder } = props;

  const states = {
    primary: `
      color: ${hasBorder ? theme.primary.normal : theme.text.text100};
      background-color: ${hasBorder ? 'transparent' : theme.primary.normal};
      border-color: ${hasBorder ? theme.primary.normal : 'transparent'};
      &:active {
        background-color: ${theme.primary.primary400};
        color: ${theme.text.text100};
      }
      &[disabled] {
        background: ${hasBorder ? 'none' : theme.disabled.disabled100};
        border: ${
          hasBorder ? `1px solid ${theme.disabled.disabled100}` : 'none'
        };
        color: ${hasBorder ? theme.disabled.disabled100 : 'white'};
      }
      & .lsCommonClientButtonLoader {
        background-color: ${theme.primary.normal};
      }
    `,
    secondary: `
      color: ${hasBorder ? theme.secondary.normal : theme.text.text100};
      background-color: ${hasBorder ? 'transparent' : theme.secondary.normal};
      border-color: ${hasBorder ? theme.secondary.normal : 'transparent'};
      &:active {
        background-color: ${theme.secondary.secondary400};
        color: ${theme.text.text100};
      }
      & .lsCommonClientButtonLoader {
        background-color: ${theme.secondary.normal};
      }
    `,
    default: `
      color: ${theme.primary.normal};
      background-color: ${hasBorder ? 'transparent' : theme.primary.normal};
      border: solid 1px ${theme.primary.normal};
      &:hover {
        background-color: ${theme.primary.normal};
        color: ${theme.text.text100};
      }
      &:active {
        background-color: ${theme.primary.primary400};
        color: ${theme.text.text100};
      }
      &[disabled] {
        background: none;
        border-color: ${theme.disabled.disabled100};
        color: ${theme.disabled.disabled100};
      }
      & .lsCommonClientButtonLoader {
        background-color: ${theme.primary.normal};
      }
    `,
  };
  const state = Object.keys(states).find(key => props[key]);

  return states[state];
};

const StyledButton = styled.button`
    position:relative;
    display: inline-block;
    box-sizing: border-box; 
    height: 44px;
    width: 100%;
    min-width: 120px;
    border: ${props =>
      props.border ? `1px solid ${props.theme.text.text300}` : 'none'};
    padding-left: ${props => props.theme.padding.normal};
    padding-right: ${props => props.theme.padding.normal};
    font-size: ${props => props.theme.fontSize.normal};
    font-weight: 600;
    border-radius: ${props => (props.rounded ? '100px' : '4px')} ;
    white-space: nowrap;
    cursor: pointer;
    appearance: none;
    user-select: none;
    outline: none;
    text-overflow: ellipsis;
    overflow: hidden;
    color: ${props => props.theme.text.text400};
    font-family: ${props => props.theme.font.circular};
    &:hover {
        ${props =>
          props.border
            ? `border: 1px solid ${props.theme.primary.primary200}`
            : `box-shadow: ${props.theme.shadow.button}`}
    }
    &:active {
        box-shadow: none;
    }
    &[disabled] {
      background: ${props =>
        props.border ? 'none' : props.theme.disabled.disabled100};
      border: ${props =>
        props.border
          ? `1px solid ${props.theme.disabled.disabled100}`
          : 'none'};
      &:hover {
        box-shadow: none;
        cursor: not-allowed;
      }
    }
    ${style}
    ${background()}
    ${dimension()}
    ${margin()}
    ${padding()}
    ${display()}
    ${flexParent()}
    ${flexChild()}
    ${font()}
    ${border()}
    ${position()}
`;

const loaderStyle = props => {
  const { theme } = props;

  const states = {
    primary: `
      background-color: ${theme.primary.normal};
    `,
    secondary: `
      background-color: ${theme.secondary.normal};
    `,
    default: `
      background-color: ${theme.primary.normal};
    `,
  };
  const state = Object.keys(states).find(key => props[key]);

  return states[state];
};

const StyledLoader = styled(Container)`
  ${loaderStyle}
`;

const Button = ({ loading, children, ...props }) => (
  <StyledButton {...props}>
    {loading && (
      <StyledLoader
        className="lsCommonClientButtonLoader"
        position="absolute"
        left="0"
        top="0"
        width="100%"
        height="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <LoaderLight marginBottom="-5px" width="130px" />
      </StyledLoader>
    )}
    {children}
  </StyledButton>
);

Button.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.node,
};

Button.defaultProps = {
  loading: false,
  children: null,
};

export default Button;
